<template>
  <div class="flex justify-center m-2">
    <img src="../../assets/icon.svg" class="layup-icon" />
  </div>
</template>
